import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { SwiftimmoTemplateProvider } from '../providers/swiftimmo-template/swiftimmo-template';
import { ComponentsModule } from '../components/components.module';
import { FileUploadModule } from "angular-file-uploader";

import { HttpModule } from '@angular/http';
import { NgxJsonViewerProvider } from '../providers/ngx-json-viewer/ngx-json-viewer';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule,MatInputModule } from '@angular/material';
import { MatSelectModule,MatOptionModule,MatFormFieldModule } from '@angular/material';

@NgModule({
  declarations: [
    MyApp,
    HomePage
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp),
    HttpModule,
    FileUploadModule,
    CommonModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule.forRoot(),
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    MatOptionModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [
            MatButtonModule,
            MatCheckboxModule,
            MatSelectModule,
            MatOptionModule,
            MatFormFieldModule
            ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: Window, useValue: window},
    {provide: Document, useValue: document},
    SwiftimmoTemplateProvider,
    {
        provide : HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi   : true,
    },
    NgxJsonViewerProvider    
  ],
  schemas: [ NO_ERRORS_SCHEMA ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts